var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPerson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 7.54531C12.9455 7.54531 10.8676 9.62328 10.8676 12.1777C10.8676 14.7322 12.9455 16.8102 15.5 16.8102C18.0545 16.8102 20.1324 14.7322 20.1324 12.1777C20.1324 9.62328 18.0545 7.54531 15.5 7.54531ZM15.5 15.5141C13.6605 15.5141 12.1637 14.0173 12.1637 12.1777C12.1637 10.3382 13.6605 8.84141 15.5 8.84141C17.3395 8.84141 18.8363 10.3382 18.8363 12.1777C18.8363 14.0173 17.3395 15.5141 15.5 15.5141Z",
    fill: "#25368D",
    stroke: "#25368D",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1839 19.4833C19.9289 18.209 18.2637 17.5062 16.4961 17.5062H14.5039C12.7363 17.5062 11.0711 18.209 9.81613 19.4833C8.56747 20.7511 7.8793 22.4256 7.8793 24.1973C7.8793 24.5552 8.16945 24.8453 8.52734 24.8453H22.4727C22.8306 24.8453 23.1207 24.5552 23.1207 24.1973C23.1207 22.4256 22.4325 20.7511 21.1839 19.4833ZM21.7864 23.5492H9.21361C9.53076 20.8775 11.7839 18.8023 14.5039 18.8023H16.4961C19.2161 18.8023 21.4692 20.8775 21.7864 23.5492Z",
    fill: "#25368D",
    stroke: "#25368D",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPerson);
export default __webpack_public_path__ + "static/media/icon-person.2f4fd6c6f1bf34570464bd058f98cb18.svg";
export { ForwardRef as ReactComponent };